import type { LocaleCode, Money } from '@sshop/domain';

const localeMap: Record<LocaleCode, string> = {
  ge: 'ka-GE',
  en: 'en-US',
};

/**
 * Locale-aware Money formatter. GEL displays use the lari sign after the
 * amount in both storefront languages.
 *
 *   formatMoney({ amount: 1299, currency: 'GEL' }, 'ge') → "1 299 ₾"
 *   formatMoney({ amount: 1299, currency: 'USD' }, 'en') → "$1,299"
 */
export function formatMoney(value: Money, locale: LocaleCode): string {
  if (value.currency === 'GEL') {
    const amount = new Intl.NumberFormat(localeMap[locale], {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value.amount);

    return `${amount}\u00a0₾`;
  }

  const formatter = new Intl.NumberFormat(localeMap[locale], {
    style: 'currency',
    currency: value.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(value.amount);
}
